import {
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
} from '@cian/ui-kit-design-tokens/icons';
import { IIconProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

// @ts-expect-error Цвета приходят с сервера, просто так не поправить
const REGION_METRO_ICON_MAP = new Map<number, React.ComponentType<IIconProps>>([
  [1, IconMapMetroMsk16],
  [2, IconMapMetroSpb16],
  [4612, IconMapMetroEkb16],
  [4618, IconMapMetroKzn16],
  [4596, IconMapMetroNN16],
  [4598, IconMapMetroNovosib16],
  [4608, IconMapMetroSam16],
]);

export function getRegionUndergroundIcon(regionId: number[]): React.ComponentType<IIconProps> {
  const availableRegionId = regionId.find(id => REGION_METRO_ICON_MAP.has(id));

  // @ts-expect-error Цвета приходят с сервера, просто так не поправить
  return (availableRegionId && REGION_METRO_ICON_MAP.get(availableRegionId)) || IconMetroMsk16;
}
